import { Component } from '@angular/core';

@Component({
  selector: 'reports',
  templateUrl: 'reports.component.html',
  styleUrls: ['reports.component.css'],
})
export class ReportsComponent {
  showFiller = false;

  selectedItem: number = 2;

  constructor() {
  }

  itemSelected(index: number) {
    this.selectedItem = index;
  }

  isItemSelected(index: number) {
    return index == this.selectedItem;
  }

  itemStyle(index: number) {
    if (this.isItemSelected(index)) {
      return { 'color': '#7AB800' };
    }
    else {
      return { 'color': 'black' };
    }
  }
}
